import { Injectable, Inject } from "@angular/core";
import { IHttpClient } from "../../interface/http-client";
import {
  Http,
  Response,
  Headers,
  RequestOptions,
  ResponseContentType
} from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { IAppConfig } from "../../interface/app-config";
import { IHeader } from "../../interface/iheader";
import { APP_CONFIG } from "../../constant/app-constant";
import { HttpService } from "./interceptor-service.service";

@Injectable()
export class HttpClientService implements IHttpClient {
  Uri: string = "";
  GrantType: string = "";
  header: Headers = null;
  url: string = "";
  data: any = null;
  files: any[] = null;
  constructor(
    @Inject(APP_CONFIG) private config: IAppConfig,
    public http: HttpService
  ) {
    this.Uri = config.URL_PATH;
    this.GrantType = config.GRANT_TYPE;
  }

  public setPath(path: string): void {
    this.url = this.Uri + path;
  }
  public setHeader(header: IHeader[]): void {
    this.header = null;
    if (header !== null) {
      this.header = new Headers();
      header.forEach(element => {
        this.header.append(element.key, element.value);
      });
    }
  }
  public setData(data: any): void {
    this.data = data;
  }
  public setFiles(files: any[]): void {
    this.files = files;
  }

  public getDataWithUrlEncode(data: string): Observable<any> {
    return this.http
      .post(this.url, data, {
        headers: this.header
      })
      .map(res => <any>res.json());
  }
  public getData(): Observable<any> {
    return this.http
      .get(this.url, {
        headers: this.header
      })
      .map(res => <any>res.json());
  }

  public loadFileFromUrl(): Observable<unknown> {
    return this.http.get(this.url, {
      headers: this.header,
      responseType: ResponseContentType.ArrayBuffer
    });
  }
  public postDataWithFile(header: IHeader[]): Observable<any> {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i] !== undefined) {
          formData.append(
            this.files[i].text ? this.files[i].text : "uploads[]",
            this.files[i].file ? this.files[i].file : this.files[i],
            this.files[i].name
          );
        }
      }
      let postData = this.data;
      Object.keys(postData).forEach(function(key) {
        formData.append(key, postData[key]);
      });

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.open("POST", this.url, true);
      if (header !== null) {
        header.forEach(element => {
          xhr.setRequestHeader(element.key, element.value);
        });
      }
      xhr.send(formData);
    });
  }
  public postData(): Observable<any> {
    return this.http
      .post(this.url, this.data, {
        headers: this.header
      })
      .map(res => <any>res.json());
  }
  public putData(): Observable<any> {
    return this.http
      .put(this.url, this.data, {
        headers: this.header
      })
      .map(res => <any>res.json());
  }
  public deleteData(): Observable<any> {
    return this.http
      .delete(this.url, {
        headers: this.header
      })
      .map(res => <any>res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/http/http-client.service.ts